/**
 * Add Tickets hides cancelled, closed, postponed, and deactivated events.
 * Offsale events stay visible so tickets can still be added.
 */
const BLOCKED = new Set([
  "closed",
  "postponed",
  "cancelled",
  "canceled",
  "unnecessary",
  "deactivated",
  "deactive",
]);

export function isEventEligibleForAddTickets(event: {
  e_status?: string | null;
  e_is_active?: boolean | null;
}): boolean {
  const normalized = String(event?.e_status ?? "")
    .toLowerCase()
    .trim();
  const isActive = event?.e_is_active !== false;
  return isActive && !BLOCKED.has(normalized);
}
